import { HttpResponse } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { TypePracticeData } from 'shell/models/type-practice';
import { FormTypePracticeVM } from 'practice/components/type-practice/form';

export const typePracticeResponseTransformer = (
  response: AxiosResponse<HttpResponse<TypePracticeData>>
): FormTypePracticeVM => {
  const { data } = response;
  const item = data.payload;
  return {
    code: item.key?.tipoPratica || '',
    description: item.descrizioneTipoPratica || '',
    descriptionBrief: item.descrizioneBreveTipoPratica || '',
    typeInitiative: item.tipoIniziativa || '',
    measure: item.unitaMisuraTempo || '',
    typeRegister: item.tipoRegistro || '',
    timeMax: item.tempoMax || undefined,
    timeStandard: item.tempoStandard || undefined,
  };
};
